var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgImage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.7 202.3H74.8C68.1 202.3 62.6 196.8 62.6 190.1V80.6C62.6 73.9 68.1 68.4 74.8 68.4H208.7C215.4 68.4 220.9 73.9 220.9 80.6V190.2C220.9 196.9 215.4 202.3 208.7 202.3ZM74.8 80.6V190.2H208.7V80.6H74.8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.8 184.1C213.2 184.1 211.7 183.5 210.5 182.3L178.3 150.1L162.5 165.9C160.2 168.2 157.1 169.5 153.8 169.4C150.6 169.4 147.5 168.1 145.3 165.8L111.3 131.8L73 170.1C70.6 172.5 66.8 172.5 64.4 170.1C62 167.7 62 163.9 64.4 161.5L102.7 123.2C105 120.9 108 119.6 111.2 119.6C114.5 119.6 117.6 120.8 119.9 123.1L153.9 157.1L169.6 141.4C174.4 136.6 182.1 136.6 186.8 141.3L219.1 173.6C221.5 176 221.5 179.8 219.1 182.2C217.9 183.5 216.4 184.1 214.8 184.1Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.1 123.1C168.126 123.1 172.2 119.026 172.2 114C172.2 108.974 168.126 104.9 163.1 104.9C158.074 104.9 154 108.974 154 114C154 119.026 158.074 123.1 163.1 123.1Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/image.816a4c33.svg";
export { ForwardRef as ReactComponent };